import subscribe from '../lib/subscribe'
import merge from '../lib/merge'

import {
  REALTIME_STORY_SHOW_PAGE_COMMENT_CREATED,
  REALTIME_STORY_SHOW_PAGE_COMMENT_DELETED,
  REALTIME_STORY_SHOW_PAGE_COMMENT_LIKED,
  REALTIME_STORY_SHOW_PAGE_COMMENT_UNLIKED,
  REALTIME_STORY_SHOW_PAGE_STORY_LIKED,
  REALTIME_STORY_SHOW_PAGE_STORY_UNLIKED,
} from '../../actions/constants'

export default function registerRealtimeUpdatesEffect() {
  return merge([
    subscribe(
      { channel: 'CommentCreatedChannel' },
      REALTIME_STORY_SHOW_PAGE_COMMENT_CREATED
    ),
    subscribe(
      { channel: 'CommentDeletedChannel' },
      REALTIME_STORY_SHOW_PAGE_COMMENT_DELETED
    ),
    subscribe(
      { channel: 'CommentLikeChannel' },
      REALTIME_STORY_SHOW_PAGE_COMMENT_LIKED
    ),
    subscribe(
      { channel: 'CommentUnlikeChannel' },
      REALTIME_STORY_SHOW_PAGE_COMMENT_UNLIKED
    ),
    subscribe(
      { channel: 'StoryLikeChannel' },
      REALTIME_STORY_SHOW_PAGE_STORY_LIKED
    ),
    subscribe(
      { channel: 'StoryUnlikeChannel' },
      REALTIME_STORY_SHOW_PAGE_STORY_UNLIKED
    ),
  ])
}
